const entities = {}

// {
//   name: 'industry_id',
//   label: 'Toimiala',
//   type: 'reference',
//   validation: [],
//   referenceConfig: {
//     entity: 'industry'
//   }
// }

const DEFAULT_FIELDS = {
  title: {
    name: 'title',
    label: 'Nimi',
    type: 'text',
    validation: ['required'],
    column: true,
    link: true,
  },
}

// Company
entities['organization'] = {
  title: 'Organisaatiot',
  singular: 'yritys',
  icon: 'building',
  apiRoot: '/organization',
  fields: [
    DEFAULT_FIELDS.title,
    {
      name: 'industry_code',
      label: 'Toimiala',
      type: 'industry',
      validation: [],
    },
  ],
}

// User
entities['user'] = {
  title: 'Käyttäjät',
  singular: 'käyttäjä',
  icon: 'user',
  apiRoot: '/user',
  fields: [
    {
      name: 'email',
      label: 'Sähköposti',
      type: 'email',
      validation: ['required', 'email'],
      link: true,
      column: true,
    },
    {
      name: 'password',
      label: 'Salasana',
      type: 'password',
      validation: ['required', 'min:8'],
    },
  ],
}

export default entities
